import { MutationTree } from 'vuex'
import { AuctionState } from './AuctionState'
import { Offer } from './Offer'
import { SendEncryptedOfferResponseDto } from '@/Application/XmlOffer/SendEncryptedOfferResponseDto'
import store from '@/Infrastructure/Store'

export const mutations: MutationTree<AuctionState> = {
  clearAuctionAll: (state: AuctionState) => {
    store.dispatch('auction/clearAuction')
    state.lastWizardStep = 1
    state.offers = []
    state.resultPost = new SendEncryptedOfferResponseDto('', [])
  },
  clearAuctionB: (state: AuctionState) => {
    state.lastWizardStep = 1
    state.offers = []
    state.resultPost = new SendEncryptedOfferResponseDto('', [])
  },
  setLastWizardStep (state: AuctionState, payload: number) {
    state.lastWizardStep = payload
  },
  upsertOffer (state: AuctionState, payload: Offer) {
    let offerUpdated = false
    const updatedOffers = state.offers.map(current => {
      if (current.batchId === payload.batchId) {
        offerUpdated = true
        return payload
      }
      return current
    })
    if (offerUpdated === false) {
      updatedOffers.push(payload)
    }
    state.offers = updatedOffers
  },
  clearOffers (state: AuctionState) {
    state.lastWizardStep = 1
    state.offers = []
  },
  setResultPost (state: AuctionState, payload: SendEncryptedOfferResponseDto) {
    state.resultPost = payload
  }
}
